import {
  MIX_PANEL_ACTION_TYPES,
  MIX_PANEL_ACTION_TYPES_LABEL,
  MIX_PANEL_ACTIONS,
} from "constants/common.constants";
import mixpanel from "mixpanel-browser";

export const normalizeUppercaseString = (str) => {
  if (str) return `${str.slice(0, 1).toUpperCase()}${str.slice(1).toLowerCase()}`;
  return "";
};

export const normalizeSnakeCaseString = (str) => {
  if (!str || typeof str !== "string") return;
  const splitStr = str.split("_");

  return splitStr.map((s) => normalizeUppercaseString(s)).join(" ");
};

export const filterDatasetByStatus = (data) => {
  const statusesFilter = ["in_progress", "failed"];

  if (!data) return [];
  return data.filter((item) => !statusesFilter.includes(item.status));
};

export const getGraphTitle = (graph, routeKey = "") => {
  if (graph === "null") return "heatmap";

  if (graph === "singlemodel") return routeKey;

  return graph;
};

export const downloadFile = (url, fileName = "") => {
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
};

export const gaClickCallback = ({
  type = MIX_PANEL_ACTION_TYPES.BUTTON,
  action = MIX_PANEL_ACTIONS.CLICK,
  label = "",
  callback = () => {},
}) => {
  const labelWithAction = `${MIX_PANEL_ACTION_TYPES_LABEL[type]} - ${label}`;

  mixpanel.track(labelWithAction, {
    action,
    label,
    type,
  });
  !!callback && callback();
};

export const sortingByNotNullFirst = (data) => {
  if (!data || !Object.keys(data)?.length) return [];
  return Object.keys(data).sort((a, b) => {
    if (data[a] === null && data[b] !== null) return 1;
    if (data[a] !== null && data[b] === null) return -1;
    return 0;
  });
};
